import Vue        from 'vue/dist/vue.esm';
import Components from './components'
import I18n       from './i18n';

// Suprimir warnings de compilación de templates
Vue.config.silent = true;
Vue.config.warnHandler = function (msg, vm, trace) {
  // Ignorar warnings de templates (como los del mapa con Leaflet)
  if (msg.includes('Error compiling template') || msg.includes('side-effects')) {
    return;
  }
  console.warn('[Vue warn]: ' + msg + trace);
};

Vue.prototype.$I18n=I18n;
const A={
  UI:{
    render:(selector)=>{
      return new Vue({
        el: selector,
        components: Components,
        beforeMount:function(){
          this.$I18n.locale(this.$el.getAttribute("locale"));
        }
      });
    }
  }
}
export default A;